import { Button, Checkbox, Col, Row, Typography } from "antd";
import React, { useState } from "react";
import { formatDateInMMDDYYYY } from "../../helpers/date";
import { orderStatusEnums } from "../../helpers/enums";
import OrderDropDown from "../Items/order-items/OrderDropDown";
import ChatIcon from "./../../graphics/svgs/chatIcon.svg";
import PrintIcon from "./../../graphics/svgs/printIcon.svg";
import PrintDropDown from "../Items/order-items/PrintDropDown";
import RefundConfirmationModal from "../../modals/RefundConfirmationModal";
const DashboardTableRow: React.FC<IDashboardTableRow> = ({
  activeBg,
  order,
}) => {
  const { shippingDetails } = order;
  const [showRefundModal, setShowRefundModal] = useState<boolean>(false);
  const isRefunded = order.processingDetails.orderStatus === orderStatusEnums.REFUNDED;
  const handleOpenPdf = (pdfUrl: string) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank"; // Opens in a new tab
    link.rel = "noopener noreferrer";
    link.click();
  };
  return (
    <>
      {showRefundModal && (
        <RefundConfirmationModal
          show={showRefundModal}
          handleClose={(e) => setShowRefundModal(false)}
          order={order}
        />
      )}
      <Row
        style={{ background: activeBg }}
        gutter={[16, 16]}
        className="table-single-row-container"
      >
      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-customer-name">
          {order.user.firstName} {order.user.lastName}
        </Typography>
        <Typography className="users-table-customer-phone">
          {order.user.phoneNumber || ""}
        </Typography>
        <Typography className="users-table-customer-phone">
          {order.user.email}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          {`${shippingDetails.address.street1}${
            shippingDetails.address.street2
              ? `, ${shippingDetails.address.street2}`
              : ""
          }, ${shippingDetails.address.city}, ${
            shippingDetails.address.state
          } ${shippingDetails.address.zipCode}`}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-generic-label">
          {order.painProfile.painRating}{" "}
          {formatDateInMMDDYYYY(order.createdAt, true)}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          # {order.processingDetails.orderNumber}
        </Typography>

        <Typography
          className="order-prescribed-tag"
          style={{
            color: isRefunded ? "#ff4d4f" : undefined,
            fontWeight: isRefunded ? "600" : undefined,
          }}
        >
          {order.processingDetails.orderStatus}
        </Typography>
        {isRefunded && (
          <Typography
            style={{
              color: "#ff4d4f",
              fontSize: "12px",
              fontWeight: "600",
              marginTop: "4px",
            }}
          >
            Refunded
          </Typography>
        )}
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          {order.processingDetails.formulaAssigned !== null
            ? `${order.processingDetails.formulaAssigned?.activeIngredients},${order.processingDetails.formulaAssigned?.creamBase}`
            : "---"}
        </Typography>
      </Col>
      <Col className="table-cell-hrz" span={6}>
        {order.isFirstOrder === true && (
          <Typography className="first-order-tag">1st time order</Typography>
        )}
        {/* <img
          src={PrintIcon}
          onClick={(e) => {
            if (
              order.processingDetails.orderStatus ===
                orderStatusEnums.ASSIGNED_RX &&
              order.processingDetails.shippingLabel !== null
            ) {
              handleOpenPdf(order.processingDetails.shippingLabel);
            }
          }}
          style={{ width: "25px", cursor: "pointer" }}
        /> */}
        <PrintDropDown order={order} />
        <Checkbox />
        <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
        <OrderDropDown order={order} />
        {!isRefunded && (
          <Button
            type="primary"
            danger
            size="small"
            onClick={() => setShowRefundModal(true)}
            style={{
              marginLeft: "8px",
              backgroundColor: "#ff4d4f",
              borderColor: "#ff4d4f",
            }}
          >
            Refund
          </Button>
        )}
        {/* <img src={ThreeDotsHrz} style={{ width: "25px", cursor: "pointer" }} /> */}
      </Col>
    </Row>
    </>
  );
};
export default DashboardTableRow;
